import {
  getStaffRequest,
  listAvailableRolesRequest,
  updateStaffPermissionsRequest,
} from '@vyce/core/src/api/companies';
import {
  getCompanyPermissionsCatalogueRequest,
  getUserPermissionOverridesRequest,
  getUserResourcePermissionOverridesRequest,
  previewPermissionOverridesRequest,
  updateResourcePermissionOverrideRequest,
  updateUserPermissionOverridesRequest,
} from '@vyce/core/src/api/permissions';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';
import { MANAGEMENT_PERMISSIONS } from '@vyce/core/src/types';

// Everything on /public/v1 — the roles module takes its requests by injection so
// the same editor serves legend-app (/admin/v1) and pay-app.
export const useModuleData = () => {
  const { can } = usePermissions();

  return {
    canEdit: can(MANAGEMENT_PERMISSIONS.MANAGE_STAFF_ROLES),
    getStaffRequest,
    listAvailableRolesRequest,
    updateStaffPermissionsRequest,
    getCompanyPermissionsCatalogueRequest,
    getUserPermissionOverridesRequest,
    updateUserPermissionOverridesRequest,
    previewPermissionOverridesRequest,
    getUserResourcePermissionOverridesRequest,
    updateResourcePermissionOverrideRequest,
  };
};
